<template>
<Paper class="process-barcode">
    <div class="history-bar-track">
        <el-row type="flex" class="process-barcode-search row-bg" justify="space-between">
            <el-col :span="22">
                <el-row>
                    <el-col class="sn-search-item">
                        <el-input v-model="searchData['barcodeNo']" placeholder="条码"></el-input>
                    </el-col>
                    <el-col class="sn-search-item">
                        <el-input v-model="searchData['billNo']" placeholder="单据号"></el-input>
                    </el-col>
                    <div class="search-margin">
                        <el-button type="primary" :loading="searchLoading" size="mini" @click="searchChange" icon='el-icon-search'>
                            {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                        </el-button>
                        <el-button class="sn-search-reset-button" @click="restSearchChange" size="mini">
                            {{$translate('lang.E3202101260009', { defaultText: '重 置' })}}
                        </el-button>
                    </div>
                </el-row>
            </el-col>
        </el-row>
        <div class="btnExport">
            <el-button size="mini" type="primary" @click="batchOperation">批量查询导出</el-button>
        </div>
        <MTable :config="tableConfig" :pageTotal="pageTotal" :tableData="tableData" @pageChange="pageChange" @sizeChange="sizeChange">
        </MTable>
        <el-dialog title="批量查询导出" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
            <el-upload class="upload-demo" ref="upload" action="" :file-list="fileList" :auto-upload="false" :on-remove="handleRemove" :on-change="fileChange">
                <el-button size="small" type="primary">上传</el-button>
            </el-upload>
            <el-collapse value='1' class="processSearchTotal-collapse">
                <el-collapse-item title="模板" name="1">
                    <MExport :url='templateExport.exportUrl' :params='templateExport.exportParams' :name='templateExport.exportName' :exportFlag='templateExport.exportFlag' :type='templateExport.type'
                        :listData='listData' :linkFlag="true" :titleText='templateExport.titleText'>
                    </MExport>
                </el-collapse-item>
            </el-collapse>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="exportListFile" type="primary" :loading="detailLoading">查询导出</el-button>
            </span>
        </el-dialog>
    </div>
</Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import MTable from '../../../components/IdentityComponent/Main';
import MExport from '../component/export';
import { config } from './Config';
import { historyBarcodeQuery, uploadProcess } from '../../../api/lcbsManagement.js';
import { exportType } from '../../../api/logManagement';
const FIRE_SIZE = 1 * 1024 * 1024;// 文件大小1M
const EXPORTPROCESS = '/api-sn/lbcs/barcodeFullProcessTracking/searchOldSwapExport';
export default {
    components: { Paper, MTable, MExport },
    data() {
        return {
            tableConfig: config,
            searchData: {},
            tableData: [],
            pageNo: config.page.pageNo,
            pageSize: config.page.pageSize,
            pageTotal: 0,
            searchLoading: false,
            dialogVisible: false,
            templateFlie: {},
            fileList: [],
            listData: [],
            listExport: {
                exportUrl: '/api-sn/lbcs/barcodeFullProcessTracking/export',
                exportName: this.$translate('lang.E3202101280016', { defaultText: '条码全流程信息查询列表.xlsx' }),
                exportParams: {},
                titleText: this.$translate('lang.E3202101260010', { defaultText: '导出Excel' }),
                exportFlag: 0
            },
            templateExport: {
                exportUrl: '/api-sn/lbcs/barcodeFullProcessTracking/templates/download',
                exportName: this.$translate('lang.E3202101280017', { defaultText: 'LBCS条码全流程批量查询模板.xlsx' }),
                exportParams: {},
                titleText: this.$translate('lang.E3202101260014', { defaultText: '批量查询模板下载' }),
                exportFlag: 1,
                type: 'get'
            },
            detailLoading: false
        };
    },
    methods: {
        pageChange(data) {
            this.pageNo = data;
            this.loadData();
        },
        sizeChange(data) {
            this.pageSize = data;
            this.loadData();
        },
        loadData() {
            const params = {
                ...this.searchData,
                pageNo: this.pageNo,
                pageSize: this.pageSize
            };
            this.searchLoading = true;
            historyBarcodeQuery(params).then(res => {
                if (res.code === '0') {
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.searchLoading = false;
            });
        },
        searchChange() {
            this.pageNo = 1;
            this.loadData();
        },
        restSearchChange() {
            this.searchData = this.$options.data.call(this).searchData;
        },
        batchOperation() {
            this.dialogVisible = true;
        },
        handleClose() {
            this.dialogVisible = false;
            this.templateFlie = {};
            this.listExport.exportFlag = 0;
            this.$refs.upload.clearFiles();
        },
        handleRemove(file) {
            this.templateFlie = {};
            this.$refs.upload.clearFiles();
        },
        fileChange(file, fileList) {
            if (fileList.length > 0) {
                this.fileList = [fileList[fileList.length - 1]];
            }
            const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
            if (testmsg !== 'xlsx' && testmsg !== 'xls') {
                this.$message({
                    message: this.$translate('lang.EXC202407010001', { defaultText: '表格上传类型不正确,仅支持上传xls，跟xlsx两种格式' }),
                    type: 'warning'
                });
                this.$refs.upload.clearFiles();
                this.templateFlie = {};
                this.fileList = [];
            } else {
                this.templateFlie = file;
            }
        },
        exportListFile() {
            if (!this.templateFlie.name) {
                this.$message.warning('请先上传文件');
                return;
            };
            if (this.templateFlie.size > FIRE_SIZE) {
                this.$message.warning('文件大小不得超过1024KB，请修改后上传！');
                return;
            };
            const form = new FormData();
            form.append('file', this.templateFlie.raw);
            form.append('isReadTheEnd', this.searchData.isReadTheEnd);
            uploadProcess(form).then(res => {
                if (res && +res.code === 0) {
                    const barcodeBatchNo = res.data;
                    this.detailLoading = true;
                    const url = EXPORTPROCESS;
                    const type = 'post';
                    const name = '历史条码流向跟踪批量查询.xls';
                    exportType({ barcodeBatchNo }, url, type, name, () => { this.detailLoading = false; });
                    this.dialogVisible = false;
                }
            });
        }
    }
};
</script>
<style lang="less">
.history-bar-track {
    .nPanel .el-table {
        height: calc(100vh - 269px) !important;
    }
}
.btnExport {
    display: flex;
    padding: 10px 0;
    .el-button {
        margin-right: 15px;
        margin-left: 0px;
    }
    .el-upload-list__item {
        margin-top: 5px;
    }
}
</style>
